module.exports = __webpack_public_path__ + "static/media/cta-list.7f49e715.svg";